import React from 'react'
import { APIEntity, MainProductAPIEntity } from 'services/api/entities'
import { CatalogItemBase } from 'services/api/entities/catalog/catalogItemBase/types/internal/catalogItemBase-models'
import { MainProduct } from 'services/api/entities/catalog/mainProduct/types/internal/mainProduct-models'
import {
  ProductSection,
  TailoredProduct,
} from 'services/api/entities/catalog/types'
import { useKRecordContext } from 'services/hooks/useKRecordContext'
import { hasSections } from 'services/utils'
import { CustomFormProps, WithId } from 'types/common'
import CustomReferenceInput from 'ui-shared/CustomInputs/CustomReferenceInput'
import LocalizedSelectArrayInput from 'ui-shared/LocalizedFields/LocalizedSelectArrayInput'
import CatalogItemBaseForm from './CatalogItemBaseForm'

type ProductEntity = Extract<APIEntity, MainProductAPIEntity | 'eventpackages'>

type TailoredProductWithId = TailoredProduct & WithId

export type ProductSectionFormProps = CustomFormProps & {
  canAssignProductToMultipleSections?: boolean
  entity: ProductEntity
}

export const filterNoTailoredProducts = (e: TailoredProductWithId) =>
  !e.customers.length && !e.organizations.length

const filterBySectionAssigned = (d: MainProduct) => !hasSections(d)

const ProductSectionForm: React.FC<ProductSectionFormProps> = ({
  entity,
  children,
  canAssignProductToMultipleSections = true,
  ...props
}) => {
  const record = useKRecordContext<ProductSection<CatalogItemBase>>()

  const filterFns = [
    // if the flag is true (by default) then don't filter
    // else filter only the products that have not have a section
    canAssignProductToMultipleSections ? () => true : filterBySectionAssigned,
    filterNoTailoredProducts,
  ]

  return (
    <CatalogItemBaseForm {...props}>
      {children}
      <CustomReferenceInput
        filterFns={filterFns}
        entity={entity}
        additionalChoices={record?.productsFull}
      >
        <LocalizedSelectArrayInput
          source="products"
          label="Products"
          fullWidth
        />
      </CustomReferenceInput>
    </CatalogItemBaseForm>
  )
}

export default ProductSectionForm
